module.exports = __webpack_public_path__ + "static/media/pic20.b0eeab5f.jpg";